<template>
  <OmtGrid>
    <OmtRow mb="24px">
      <OmtTypography as="h1-bold"> E-mail </OmtTypography>
    </OmtRow>

    <OmtRow mb="24px">
      <OmtTypography as="h3-semi-bold">
        Utilizado para o envio de comunicações sobre o seu plano, com exceção da fatura digital. O cadastro do e-mail é
        obrigatório.
      </OmtTypography>
    </OmtRow>

    <OmtRow>
      <OmtCard box-shadow="sm" border-color="transparent">
        <OmtIcons
          mb="16px"
          box-shadow="sm"
          name="envelope"
          border-radius="50%"
          height="32px"
          width="32px"
          display="flex"
          justify-content="center"
          align-items="center"
          size="lg"
        />
        <OmtCard box-shadow="sm" border-color="transparent" mb="16px">
          <template v-for="(email, index) in formEmails">
            <OmtTypography as="h3-semi-bold" mb="16px" :key="`nome-${index}`">
              {{ email.GrauParentesco }} - {{ capitalize(email.Nome) }}
            </OmtTypography>
            <CBox :mb="index === emails.length - 1 ? '0px' : '16px'" :key="`pessoal-${index}`">
              <omt-input
                :haslabel="true"
                placeholder="Digite seu e-mail"
                v-model="email.Pessoal"
                :disabled="email.disabled"
              />
            </CBox>
          </template>
        </OmtCard>
        <omt-button :style="{ width: '100%' }" :onClick="submit" :colorInverse="true" :disabled="!canSubmit">
          Continuar
        </omt-button>
      </OmtCard>
    </OmtRow>
  </OmtGrid>
</template>

<script>
import { capitalize } from "@/utils/utils";
import { CBox } from "@chakra-ui/vue";
import _ from "lodash";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    CBox
  },
  data() {
    return {
      formEmails: []
    };
  },

  async beforeMount() {
    this.formEmails = _.cloneDeep(this.emails).map(email => ({
      ...email,
      disabled: false
    }));
  },
  async mounted() {
    if (this.existEmailChangeRequest) this.handleOnExistChangeRequest();
  },
  methods: {
    ...mapMutations("myContacts", ["SET_NEW_STATE"]),
    capitalize,
    normalizeValue(value) {
      return !value ? null : value;
    },
    isValidEmail(email) {
      if (!email || email.trim() === "") {
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    },
    getEmailsAlterados() {
      if (!Array.isArray(this.formEmails)) {
        return [];
      }

      const emailsAlterados = [];

      this.formEmails.forEach((novoEmail, index) => {
        const emailOriginal = this.emails[index];

        const pessoalAlterado = this.normalizeValue(novoEmail.Pessoal) !== this.normalizeValue(emailOriginal.Pessoal);

        if (pessoalAlterado) {
          emailsAlterados.push({ index, pessoalAlterado });
        }
      });

      return emailsAlterados;
    },
    validatePessoalEmail(index, pessoal) {
      const isTitular = this.formEmails[index].GrauParentesco === "Titular";

      if (isTitular && !pessoal) {
        return false;
      }

      if (pessoal && !this.isValidEmail(pessoal)) {
        return false;
      }

      return true;
    },
    submit() {
      this.SET_NEW_STATE({ key: "newEmails", value: this.formEmails });
      this.$router.push({
        path: "/meus-contatos"
      });
    }
  },
  computed: {
    ...mapState({
      emails: state => state.myContacts.newEmails || state.myContacts.resumeContacts.Emails
    }),
    canSubmit() {
      const emailsAlterados = this.getEmailsAlterados();

      if (emailsAlterados.length === 0) {
        return false;
      }

      return emailsAlterados.every(({ index, pessoalAlterado }) => {
        if (pessoalAlterado) {
          const pessoal = this.formEmails[index].Pessoal;
          if (!this.validatePessoalEmail(index, pessoal)) {
            return false;
          }
        }

        return true;
      });
    }
  }
};
</script>
